import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Grid from '../Grid';
const StyledGrid = styled(Grid).withConfig({
  displayName: "CardComp__StyledGrid",
  componentId: "n9plkn-0"
})(["&&{margin:0 0 0 0;}"]);

const CardComp = ({
  children,
  testId
}) => {
  return /*#__PURE__*/_jsx(UICardWrapper, {
    className: "p-x-4 p-top-2 p-bottom-8",
    children: testId ? /*#__PURE__*/_jsx(StyledGrid, {
      "data-test-id": testId,
      children: children
    }) : /*#__PURE__*/_jsx(StyledGrid, {
      children: children
    })
  });
};

export default CardComp;